module.exports = __webpack_public_path__ + "img/cattunnel01.7c4057ef.jpg";